import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CedulaIdentidadRequest } from 'src/app/global/interfaces/cedula-identidad-request';
import { DatosPersonalesRequest } from 'src/app/global/interfaces/datos-personales-request';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { DatosSociosService } from 'src/app/global/services/datos-socios.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class DatosSociosProvider extends DatosSociosService {

  private api = environment.api;
  private endpoints = this.api.endpoints.PASO_2.PERSONA_JURIDICA;
  
  constructor(private http: HttpClient) {
    super();
  }

  validaCi(run: number, ci: string): Observable<GeneralResponse<any>> {
    const endopoint = this.api.host + this.api.path + this.endpoints.VALIDA_CI_SOCIO;
    const data: CedulaIdentidadRequest = {
      run,
      ci
    };
    // set header to let HTTP_INTERCEPTORS know to handle or not.
    return this.http.post<GeneralResponse<any>>(endopoint, data, { headers: { Anonymous: '' } });
  }

  validaCiPendiente(run: number, ci: string): Observable<GeneralResponse<any>> {
    const endopoint = this.api.host + this.api.path + this.endpoints.VALIDA_CI_SOCIO;
    const data: CedulaIdentidadRequest = {
      run,
      ci,
      registraPendiente: true
    };
    // set header to let HTTP_INTERCEPTORS know to handle or not.
    return this.http.post<GeneralResponse<any>>(endopoint, data, { headers: { Anonymous: '' } });
  }

  getDatosPersonales(run: number): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.SOCIO + `/${run}`;
    return this.http.get(endopoint);
  }

  registraDatosPersonales(datosPersonales: DatosPersonalesRequest): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.SOCIO;

    return this.http.post(endopoint, datosPersonales);
  }

  getSociosRegistrados(): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.SOCIOS;
    return this.http.get(endopoint);
  }

  eliminarRegistro(run: number): Observable<GeneralResponse<any>> {
    const endopoint = this.api.host + this.api.path + this.endpoints.SOCIO;
    const data = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: {
        runSocio: run
      }
    };
    return this.http.delete<GeneralResponse<any>>(endopoint, data);
  }

  getSociosEmpresa(): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.EMPRESA_UN_DIA;
    return this.http.get(endopoint);
  }

}
